import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from 'src/app/core/services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit, OnDestroy {
  protected loginFormGroup!: FormGroup;
  protected siteKey = environment.recaptchaKey;

  public isPasswordVisible = false; // Default to password being hidden
  private _sub: Subscription | undefined;

  constructor(
    private authService: AuthService,
    private router: Router,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private _snackBar: MatSnackBar,
    public translate: TranslateService,
  ) {}

  ngOnDestroy(): void {
    if (this._sub) this._sub.unsubscribe();
  }

  ngOnInit() {
    this.loginFormGroup = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      stayLoggedIn: [false, Validators.required],
      /* recaptcha: ['', Validators.required], */
    });
  }

  login() {
    if (this.loginFormGroup.valid) {
      const username = this.loginFormGroup.controls['username'].value;
      const password = this.loginFormGroup.controls['password'].value;
      const stayLoggedIn = this.loginFormGroup.controls['stayLoggedIn'].value;

      const id = this.loadingService.startLoading();

      this._sub = this.authService.login$(username, password, stayLoggedIn).subscribe((token) => {
        this.loadingService.stopLoading(id);
        if (token) {
          this.router.navigate(['/admin']);
        } else {
          this.loginFormGroup.get('username')?.reset();
          this.loginFormGroup.get('password')?.reset();
          const text = this.translate.instant('translations.login-error');
          const btn = this.translate.instant('translations.close');
          this._snackBar.open(text, btn, { duration: 2000, panelClass: 'snack' });
        }
      });
    }
  }

  public togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
